export default __webpack_public_path__ + "static/media/digital.2bf7ec9b.png";